export const ROUTES = {
  PRODUCTS: "/products",
  PRODUCTS_PROPERTIES: "/products/product-properties",
  PRODUCTS_VALUE_SETS: "/products/value-sets",
  PRODUCTS_VALUE_SETS_CREATE: "/products/value-sets/create",
  PRODUCTS_VALUE_SETS_EDIT: (id: string) =>
    `/products/value-sets/${encodeURIComponent(id)}/edit`,
  PRODUCTS_VALUE_SETS_HISTORY: (id: string) =>
    `/products/value-sets/${encodeURIComponent(id)}/history`,
  PRODUCTS_VALUE_SETS_VIEW_VERSION: (id: string, version: string) =>
    `/products/value-sets/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  PRODUCTS_VALUE_SETS_DUPLICATE: (id: string) =>
    `/products/value-sets/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS: "/formulasAndFactors",
  FORMULAS_AND_FACTORS_WIDTH_MATRIX: "/formulasAndFactors/widthMatrix",
  FORMULAS_AND_FACTORS_WIDTH_MATRIX_CREATE:
    "/formulasAndFactors/widthMatrix/create",
  FORMULAS_AND_FACTORS_WIDTH_MATRIX_EDIT: (id: string) =>
    `/formulasAndFactors/widthMatrix/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_WIDTH_MATRIX_HISTORY: (id: string) =>
    `/formulasAndFactors/widthMatrix/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_WIDTH_MATRIX_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/widthMatrix/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_WIDTH_MATRIX_DUPLICATE: (id: string) =>
    `/formulasAndFactors/widthMatrix/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_LENGTH_MATRIX: "/formulasAndFactors/lengthMatrix",
  FORMULAS_AND_FACTORS_LENGTH_MATRIX_CREATE:
    "/formulasAndFactors/lengthMatrix/create",
  FORMULAS_AND_FACTORS_LENGTH_MATRIX_EDIT: (id: string) =>
    `/formulasAndFactors/lengthMatrix/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_LENGTH_MATRIX_HISTORY: (id: string) =>
    `/formulasAndFactors/lengthMatrix/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_LENGTH_MATRIX_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/lengthMatrix/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_LENGTH_MATRIX_DUPLICATE: (id: string) =>
    `/formulasAndFactors/lengthMatrix/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION:
    "/formulasAndFactors/measurementCorrection",
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION_CREATE:
    "/formulasAndFactors/measurementCorrection/create",
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION_EDIT: (id: string) =>
    `/formulasAndFactors/measurementCorrection/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION_HISTORY: (id: string) =>
    `/formulasAndFactors/measurementCorrection/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/measurementCorrection/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CORRECTION_DUPLICATE: (id: string) =>
    `/formulasAndFactors/measurementCorrection/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE:
    "/formulasAndFactors/knittingSequence",
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE_CREATE:
    "/formulasAndFactors/knittingSequence/create",
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE_EDIT: (id: string) =>
    `/formulasAndFactors/knittingSequence/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE_HISTORY: (id: string) =>
    `/formulasAndFactors/knittingSequence/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/knittingSequence/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_KNITTING_SEQUENCE_DUPLICATE: (id: string) =>
    `/formulasAndFactors/knittingSequence/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA:
    "/formulasAndFactors/baseSizeCalculationFormula",
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA_CREATE:
    "/formulasAndFactors/baseSizeCalculationFormula/create",
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA_EDIT: (id: string) =>
    `/formulasAndFactors/baseSizeCalculationFormula/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA_HISTORY: (id: string) =>
    `/formulasAndFactors/baseSizeCalculationFormula/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/baseSizeCalculationFormula/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_BASE_SIZE_CALCULATION_FORMULA_DUPLICATE: (id: string) =>
    `/formulasAndFactors/baseSizeCalculationFormula/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR:
    "/formulasAndFactors/measurementCalculationFactor",
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR_CREATE:
    "/formulasAndFactors/measurementCalculationFactor/create",
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR_EDIT: (id: string) =>
    `/formulasAndFactors/measurementCalculationFactor/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR_HISTORY: (id: string) =>
    `/formulasAndFactors/measurementCalculationFactor/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/measurementCalculationFactor/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FACTOR_DUPLICATE: (id: string) =>
    `/formulasAndFactors/measurementCalculationFactor/${encodeURIComponent(id)}/duplicate`,
  MACHINES: "/machines",
  MACHINES_MACHINE_ASSIGNMENT: "/machines/machineAssignment",
  MACHINES_MACHINE_ASSIGNMENT_CREATE: "/machines/machineAssignment/create",
  MACHINES_MACHINE_ASSIGNMENT_EDIT: (id: string) =>
    `/machines/machineAssignment/${encodeURIComponent(id)}/edit`,
  MACHINES_MACHINE_ASSIGNMENT_HISTORY: (id: string) =>
    `/machines/machineAssignment/${encodeURIComponent(id)}/history`,
  MACHINES_MACHINE_ASSIGNMENT_VIEW_VERSION: (id: string, version: string) =>
    `/machines/machineAssignment/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  MACHINES_MACHINE_ASSIGNMENT_DUPLICATE: (id: string) =>
    `/machines/machineAssignment/${encodeURIComponent(id)}/duplicate`,
  MEASUREMENT_INSPECTIONS: "/measurementInspections",
  MEASUREMENT_INSPECTIONS_PANTY_TOP_MEASUREMENT_INSPECTION:
    "/measurementInspections/pantyTopMeasurementInspection",
  MEASUREMENT_INSPECTIONS_PANTY_TOP_MEASUREMENT_INSPECTION_CREATE:
    "/measurementInspections/pantyTopMeasurementInspection/create",
  MEASUREMENT_INSPECTIONS_PANTY_TOP_MEASUREMENT_INSPECTION_EDIT: (id: string) =>
    `/measurementInspections/pantyTopMeasurementInspection/${encodeURIComponent(id)}/edit`,
  MEASUREMENT_INSPECTIONS_PANTY_TOP_MEASUREMENT_INSPECTION_DUPLICATE: (
    id: string,
  ) =>
    `/measurementInspections/pantyTopMeasurementInspection/${encodeURIComponent(id)}/duplicate`,
  MEASUREMENT_INSPECTIONS_PANTY_TOP_MEASUREMENT_INSPECTION_HISTORY: (
    id: string,
  ) =>
    `/measurementInspections/pantyTopMeasurementInspection/${encodeURIComponent(id)}/history`,
  MEASUREMENT_INSPECTIONS_PANTY_TOP_MEASUREMENT_INSPECTION_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/measurementInspections/pantyTopMeasurementInspection/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  MEASUREMENT_INSPECTIONS_WIDTH_MEASUREMENT_INSPECTION:
    "/measurementInspections/widthMeasurementInspection",
  MEASUREMENT_INSPECTIONS_WIDTH_MEASUREMENT_INSPECTION_CREATE:
    "/measurementInspections/widthMeasurementInspection/create",
  MEASUREMENT_INSPECTIONS_WIDTH_MEASUREMENT_INSPECTION_EDIT: (id: string) =>
    `/measurementInspections/widthMeasurementInspection/${encodeURIComponent(id)}/edit`,
  MEASUREMENT_INSPECTIONS_WIDTH_MEASUREMENT_INSPECTION_HISTORY: (id: string) =>
    `/measurementInspections/widthMeasurementInspection/${encodeURIComponent(id)}/history`,
  MEASUREMENT_INSPECTIONS_WIDTH_MEASUREMENT_INSPECTION_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/measurementInspections/widthMeasurementInspection/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  MEASUREMENT_INSPECTIONS_WIDTH_MEASUREMENT_INSPECTION_DUPLICATE: (
    id: string,
  ) =>
    `/measurementInspections/widthMeasurementInspection/${encodeURIComponent(id)}/duplicate`,
  MEASUREMENT_INSPECTIONS_LENGTH_MEASUREMENT_INSPECTION:
    "/measurementInspections/lengthMeasurementInspection",
  MEASUREMENT_INSPECTIONS_LENGTH_MEASUREMENT_INSPECTION_CREATE:
    "/measurementInspections/lengthMeasurementInspection/create",
  MEASUREMENT_INSPECTIONS_LENGTH_MEASUREMENT_INSPECTION_EDIT: (id: string) =>
    `/measurementInspections/lengthMeasurementInspection/${encodeURIComponent(id)}/edit`,
  MEASUREMENT_INSPECTIONS_LENGTH_MEASUREMENT_INSPECTION_HISTORY: (id: string) =>
    `/measurementInspections/lengthMeasurementInspection/${encodeURIComponent(id)}/history`,
  MEASUREMENT_INSPECTIONS_LENGTH_MEASUREMENT_INSPECTION_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/measurementInspections/lengthMeasurementInspection/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  MEASUREMENT_INSPECTIONS_LENGTH_MEASUREMENT_INSPECTION_DUPLICATE: (
    id: string,
  ) =>
    `/measurementInspections/lengthMeasurementInspection/${encodeURIComponent(id)}/duplicate`,
  ASSETS: "/assets",
  ASSETS_KNITTING_PROGRAM_LIBRARY: "/assets/knittingProgramLibrary",
  ASSETS_KNITTING_PROGRAM_LIBRARY_CREATE:
    "/assets/knittingProgramLibrary/create",
  ASSETS_KNITTING_PROGRAM_LIBRARY_EDIT: (id: string) =>
    `/assets/knittingProgramLibrary/${encodeURIComponent(id)}/edit`,
  ASSETS_KNITTING_PROGRAM_LIBRARY_UPLOAD: (id: string) =>
    `/assets/knittingProgramLibrary/${encodeURIComponent(id)}/upload`,
  ASSETS_KNITTING_PROGRAM_LIBRARY_HISTORY: (id: string) =>
    `/assets/knittingProgramLibrary/${encodeURIComponent(id)}/history`,
  ASSETS_KNITTING_PROGRAM_HISTORY: (programId: string) =>
    `/assets/knittingProgramLibrary/programs/${encodeURIComponent(programId)}/history`,
  ASSETS_PATTERN_PROGRAMS: "/assets/patternPrograms",
  ASSETS_PATTERN_PROGRAMS_CREATE: "/assets/patternPrograms/create",
  ASSETS_PATTERN_PROGRAMS_EDIT: (id: string) =>
    `/assets/patternPrograms/${encodeURIComponent(id)}/edit`,
  ASSETS_PATTERN_PROGRAMS_HISTORY: (id: string) =>
    `/assets/patternPrograms/${encodeURIComponent(id)}/history`,
  ASSETS_MINI_PROGRAMS: "/assets/miniPrograms",
  ASSETS_MINI_PROGRAMS_CREATE: "/assets/miniPrograms/create",
  ASSETS_MINI_PROGRAMS_EDIT: (id: string) =>
    `/assets/miniPrograms/${encodeURIComponent(id)}/edit`,
  ASSETS_MINI_PROGRAMS_HISTORY: (id: string) =>
    `/assets/miniPrograms/${encodeURIComponent(id)}/history`,
  ASSETS_PANTY_TOP_PROGRAMS: "/assets/pantyTopPrograms",
  ASSETS_PANTY_TOP_PROGRAMS_CREATE: "/assets/pantyTopPrograms/create",
  ASSETS_PANTY_TOP_PROGRAMS_EDIT: (id: string) =>
    `/assets/pantyTopPrograms/${encodeURIComponent(id)}/edit`,
  ASSETS_PANTY_TOP_PROGRAMS_HISTORY: (id: string) =>
    `/assets/pantyTopPrograms/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA:
    "/formulasAndFactors/measurementCalculationFormula",
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_CREATE:
    "/formulasAndFactors/measurementCalculationFormula/create",
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_EDIT: (id: string) =>
    `/formulasAndFactors/measurementCalculationFormula/${encodeURIComponent(id)}/edit`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_HISTORY: (id: string) =>
    `/formulasAndFactors/measurementCalculationFormula/${encodeURIComponent(id)}/history`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_VIEW_VERSION: (
    id: string,
    version: string,
  ) =>
    `/formulasAndFactors/measurementCalculationFormula/${encodeURIComponent(id)}/history/${encodeURIComponent(version)}`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_DUPLICATE: (
    id: string,
  ) =>
    `/formulasAndFactors/measurementCalculationFormula/${encodeURIComponent(id)}/duplicate`,
  FORMULAS_AND_FACTORS_MEASUREMENT_CALCULATION_FORMULA_DELETE: (id: string) =>
    `/formulasAndFactors/measurementCalculationFormula/${encodeURIComponent(id)}/delete`,
} as const;
